var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryComparisons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_57115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0588 35.8235H40.7647C41.4469 35.8235 42 36.3766 42 37.0588C42 37.7411 41.4469 38.2941 40.7647 38.2941H1.23531C0.553055 38.2941 0 37.741 0 37.0588C0 36.3766 0.553055 35.8235 1.23531 35.8235H4.94115V14.8235C4.94115 14.1413 5.49421 13.5882 6.17646 13.5882H17.2941C17.9763 13.5882 18.5294 14.1413 18.5294 14.8235V35.8235H23.4705V4.94112C23.4705 4.25887 24.0236 3.70581 24.7058 3.70581H35.8235C36.5057 3.70581 37.0588 4.25887 37.0588 4.94112V35.8235H37.0588ZM7.41177 16.0588V35.8235H16.0588V16.0588H7.41177ZM25.9412 6.17643V35.8235H34.5882V6.17643H25.9412Z",
    fill: "#B77EC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_57115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryComparisons);
export default __webpack_public_path__ + "static/media/History_Comparisons.45de73cdf56518933b1c2df812ef58ab.svg";
export { ForwardRef as ReactComponent };